import React from 'react'
import * as SC from './styles';
import Cirlce from "./../../images/circle.svg";
import Losangle from "./../../images/losangle.svg";


export default function TabletDisplay({children, src}) {
  return (
    <>
      <SC.Container>
        <SC.ImageContent>
          <img src={Cirlce} className='circle'/>
          <img src={Losangle} className='losangle'/>
          <img src={src} className='photo'/>
        </SC.ImageContent>
        <SC.ChildrenContent>
          {children}
        </SC.ChildrenContent>
      </SC.Container>
    </>
  )
}